<template>
  <v-card class="mb-6 rounded-xl" color="primary" outlined flat>
    <v-system-bar color="accent" dark class="white--text pa-4">
      <span class="text-subtitle-1 ml-1">Water Tank</span>
      <v-spacer></v-spacer>
      <span class="mr-4">{{ waterTank.TankLitres }}L</span>
      <span>{{ waterTank.WaterTemperature }}°C</span>
    </v-system-bar>
    <v-card-text>
      <div class="container">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          style="display: none;"
        >
          <symbol id="wave">
            <path
              d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"
            ></path>
            <path
              d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"
            ></path>
            <path
              d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"
            ></path>
            <path
              d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"
            ></path>
          </symbol>
        </svg>
        <div class="box">
          <div id="water" class="water">
            <svg viewBox="0 0 560 20" class="water_wave water_wave_back">
              <use xlink:href="#wave"></use>
            </svg>
            <svg viewBox="0 0 560 20" class="water_wave water_wave_front">
              <use xlink:href="#wave"></use>
            </svg>
          </div>
        </div>
        <div class="image">
          <div class="percent white--text">
            <span>{{ waterTank.Tankpercent }}%</span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["waterTank"],
  data() {
    return {
      percent: 50,
    };
  },
  mounted() {
    this.start();
  },
  watch: {
    waterTank() {
      this.start();
    },
  },
  computed: {
    wifiIcon() {
      if (this.waterTank.xSSID === "Waiting") {
        return "mdi-wifi-strength-outline-off";
      } else if (this.waterTank.xRSSIpercent >= 90) {
        return "mdi-wifi-strength-4";
      } else if (this.waterTank.xRSSIpercent >= 75) {
        return "mdi-wifi-strength-3";
      } else if (this.waterTank.xRSSIpercent >= 50) {
        return "mdi-wifi-strength-2";
      } else if (this.waterTank.xRSSIpercent >= 10) {
        return "mdi-wifi-strength-1";
      } else {
        return "mdi-wifi-strength-outline";
      }
    },
  },
  methods: {
    start() {
      var water = document.getElementById("water");
      var percent = this.waterTank.Tankpercent;
      var interval;
      interval = setInterval(function() {
        water.style.transform = "translate(0" + "," + (100 - percent) + "%)";
        if (percent == 100) {
          clearInterval(interval);
        }
      }, 60);
    },
  },
};
</script>

<style lang="scss" scoped>
$bgColor: #384263;
$boxColor: #384263;
$waterFColor: #4ea8de;
$waterBColor: #5390d9;

body {
  background: $bgColor;
  -webkit-font-smoothing: antialiased;
}
.container {
  position: relative;
  width: 100%;
  height: 250px;
}

.image {
  height: 220px;
  width: 200px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-image: url(../assets/WaterEmpty.png);
  background-size: 200px;
  background-repeat: no-repeat;
  .percent {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    color: #2d3142;
    font-size: 34px;
  }
}

.box {
  height: 200px;
  width: 200px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: $boxColor;
  overflow: hidden;
  .water {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    transform: translate(0, 100%);
    background: $waterFColor;
    transition: all 6s;
    &_wave {
      width: 200%;
      position: absolute;
      bottom: 100%;
      &_back {
        right: 0;
        fill: $waterBColor;
        animation: wave-back 1.4s infinite linear;
      }
      &_front {
        left: 0;
        fill: $waterFColor;
        margin-bottom: -1px;
        animation: wave-front 0.7s infinite linear;
      }
    }
  }
}
@keyframes wave-front {
  100% {
    transform: translate(-50%, 0);
  }
}

@keyframes wave-back {
  100% {
    transform: translate(50%, 0);
  }
}
</style>
